
import { Component, Prop, Vue } from "vue-property-decorator";
import { slugify } from "@/utils/methods";

const CLASS = "status-badge";

@Component
export default class StatusBadge extends Vue {
  @Prop({ type: String, default: null }) readonly status?: string;

  get statusValue() {
    return slugify(this.status);
  }

  get computedLabel() {
    const { statusValue } = this;

    return statusValue ? this.$tc(`status.${statusValue}`) : "";
  }

  get classes() {
    const { statusValue } = this;

    return {
      [`${CLASS}_status-${statusValue}`]: statusValue,
    };
  }
}
